import React from 'react';
import { Typography } from 'fronton-react';
import { subtitleText, subtitleTopLineContainer } from './styles';

interface CarouselSubtitleProps {
  subtitle?: string;
}

export const CarouselSubtitle = ({ subtitle }: CarouselSubtitleProps) => {
  return (
    <div className={subtitleTopLineContainer}>
      <Typography
        data-qa="sponsored-carousel-subtitle"
        className={subtitleText}
        size="accent"
        variant="mini"
      >
        {subtitle}
      </Typography>
    </div>
  );
};
